export default __webpack_public_path__ + "a90369f.png";